"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggerError = exports.onError = exports.emit = exports.listen = exports.removeListener = exports.removeAllListeners = void 0;
let listeners = {};
let errorCbs = [];
function removeAllListeners() {
    listeners = {};
    errorCbs = [];
}
exports.removeAllListeners = removeAllListeners;
function removeListener(event, cb) {
    if (!listeners[event]) {
        return;
    }
    const index = listeners[event].indexOf(cb);
    if (index === -1) {
        return;
    }
    listeners[event].splice(index, 1);
}
exports.removeListener = removeListener;
function listen(event, cb, once = false) {
    if (!listeners[event]) {
        listeners[event] = [];
    }
    if (once) {
        listeners[event].push(function runOnce(payload, actionDetail) {
            removeListener(event, runOnce);
            cb(payload, actionDetail);
        });
    }
    else {
        listeners[event].push(cb);
    }
}
exports.listen = listen;
function onError(cb) {
    errorCbs.push(cb);
}
exports.onError = onError;
// Note!: we can't define a better type than 'unknown' here since all the types are defined in package one-auth
// and sdk is consumed by one-auth, so it will do a cyclic dependencies
// should be refactored and moves the types into sdk package
function emit(event, payload, actionDetail) {
    if (!listeners[event]) {
        return;
    }
    listeners[event].forEach((cb) => {
        cb(payload, actionDetail);
    });
}
exports.emit = emit;
function triggerError(scope, error, payload = {}) {
    errorCbs.forEach((cb) => {
        cb({
            scope,
            error,
            payload,
        });
    });
}
exports.triggerError = triggerError;
